"use client";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { fetchFolders } from "@/lib/api/queries/folders";
import type { Folder } from "@/lib/supabase";
import { STALE_TIME_DEFAULT_MS } from "@/lib/react-query/defaults";
import { queryKeys } from "@/lib/react-query/query-keys";

export function useFoldersQuery(workspaceId?: string | null) {
  return useQuery({
    queryKey: queryKeys.folders(workspaceId),
    queryFn: () => fetchFolders(workspaceId),
    staleTime: STALE_TIME_DEFAULT_MS,
  });
}

export function useCreateFolderMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (name: string) => {
      const res = await fetch("/api/folders", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name }),
      });
      if (!res.ok) throw new Error("Failed to create folder");
      const payload = await res.json();
      return payload.data as Folder;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["folders"] });
      void qc.invalidateQueries({ queryKey: ["home-momentum"] });
    },
  });
}
